window.recaptchaInitV3 = function recaptchaInitV3() {
    'use strict';

    let grecaptcha_field = document.querySelectorAll('.g-recaptcha-response-v3');

    if (grecaptcha_field.length > 0) {
        grecaptcha.execute(window.recaptcha_key, {
            action:'validate_captcha_v3'
        })
            .then(function(token) {
                // add token value to form
                grecaptcha_field.forEach((el) => {
                    el.value = token;
                });
            });
    }
}
